import { Autocomplete, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { customPalette } from '../themes/customTheme';
import { apiUrl, httpClient } from '../utils/httpUtils';

export const CustomSelectSections = ({
  value,
  setValue,
  field,
  label,
  filterTeam,
  disabled = false,
}) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const getData = async () => {
      try {
        let url = `${apiUrl}/sections`;
        const res = await httpClient(url);

        if (res.status === 200) {
          let { data } = await res.json;
          setData(data);
        }
      } catch (error) {
        console.error('Failed to fetch metrics:', error);
      }
    };
    getData();
    return () => {};
  }, [value, field, filterTeam]);

  return (
    <Autocomplete
      id={label}
      options={data}
      noOptionsText="Sin resultados"
      getOptionLabel={option => (option?.section ? option.section : '')}
      value={data.find(item => item.section === value) || null}
      onChange={(event, newValue) => {
        setValue(newValue ? newValue.section : '');
      }}
      disabled={disabled}
      sx={{
        minWidth: 180,
        backgroundColor: customPalette.background.main,
        borderRadius: '10px 10px 0 0 !important',
        '& > div': {
          paddingTop: '0',
          paddingBottom: '0',
          '& > div:first-of-type': {
            paddingBottom: '0',
          },
          input: {
            paddingTop: '17px !important',
          },
          '.MuiAutocomplete-endAdornment': {
            paddingTop: '10px',
          },
        },
      }}
      renderInput={params => (
        <TextField
          {...params}
          label={label}
          variant="outlined"
          InputLabelProps={{
            sx: {
              '&.Mui-focused': {
                transform: 'translate(13px, 7px) scale(0.75)',
                color: customPalette.primary.main,
                fontWeight: 500,
              },
              '&.MuiInputLabel-shrink': {
                transform: 'translate(13px, 7px) scale(0.75)',
                color: disabled
                  ? customPalette.disabled.main
                  : customPalette.primary.main,
                fontWeight: 500,
              },
            },
          }}
          sx={{
            borderRadius: '10px 10px 0 0 !important',
            height: '56px',
            paddingTop: '25px',
            paddingBottom: '8px',
            '& .MuiOutlinedInput-notchedOutline': {
              border: 'none !important',
            },
          }}
        />
      )}
    />
  );
};
